/* eslint-disable react/prop-types */
// Valve.jsx
import React from 'react'

const ValveDefault = ({ style }) => (<Valve style={style} />)

export default ValveDefault

export const Valve = ({ style }) => {
  const defaultStyle = { fill: '#284047', stroke: '#284047' }
  const svgStyle = { ...defaultStyle, ...style }
  return (
    <svg
      style={svgStyle}
      viewBox='0 0 75 75'
    >
      <description>valve icon</description>
      <title>valve</title>
      <g
        style={{
          transform: 'translate(-9px, 4px) scale(1.3)',
        }}
      >
        <path
          d='M61.9,26.2v-0.6H50.3c-0.2-0.8-1-1.4-1.9-1.4
          s-1.7,0.6-1.9,1.4h-5.9c-0.8,0-1.4-0.6-1.4-1.4v-3.5h0.6c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4h-2.6v-0.6h6.9
          c0.6,0,1.2-0.5,1.2-1.2c0-0.6-0.5-1.2-1.2-1.2h-6.9c0-0.6-0.5-1.2-1.2-1.2c-0.6,0-1.2,0.5-1.2,1.2h-6.9c-0.6,0-1.2,0.5-1.2,1.2
          c0,0.6,0.5,1.2,1.2,1.2h6.9v0.6h-2.6c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4h0.6v3.5c0,0.8-0.6,1.4-1.4,1.4h-5.9
          c-0.2-0.8-1-1.4-1.9-1.4s-1.7,0.6-1.9,1.4H10.1v0.6h11.5v10.9H10.1v0.6h11.6c0.2,0.8,1,1.4,1.9,1.4c0.9,0,1.7-0.6,1.9-1.4h3.1
          c0.9,0,2.3,0.4,3,0.9c0.1,0.1,2.1,1.4,4.4,1.4s4.3-1.3,4.4-1.4c0.7-0.5,2.1-0.9,3-0.9h3.1c0.2,0.8,1,1.4,1.9,1.4s1.7-0.6,1.9-1.4
          h11.6v-0.6H50.4V26.2H61.9z M25.1,37.2c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4V26.2c0-0.8,0.6-1.4,1.4-1.4
          c0.8,0,1.4,0.6,1.4,1.4V37.2z M36,14.4c0.3,0,0.6,0.3,0.6,0.6h-1.2C35.4,14.7,35.7,14.4,36,14.4z M27.9,16.7c-0.3,0-0.6-0.3-0.6-0.6
          c0-0.3,0.3-0.6,0.6-0.6h6.9h2.3h6.9c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6h-6.9h-2.3H27.9z M36.6,17.3v0.6h-1.2v-0.6H36.6z
          M32.3,20.2c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h2.6h2.3h2.6c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9H32.3z
          M46.4,37.2h-3c-1,0-2.5,0.5-3.3,1c0,0-2,1.3-4,1.3s-4-1.3-4-1.3c-0.8-0.6-2.3-1-3.3-1h-3V26.2h5.8c1.1,0,2-0.9,2-2v-3.5h5.2v3.5
          c0,1.1,0.9,2,2,2h5.8V37.2z M49.8,37.2c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4V26.2c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4V37.2z'
        />
      </g>
    </svg>
  )
}
